import { render, staticRenderFns } from "./r-item-trader-config.vue?vue&type=template&id=0772993c"
import script from "./r-item-trader-config.vue?vue&type=script&lang=js"
export * from "./r-item-trader-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0772993c')) {
      api.createRecord('0772993c', component.options)
    } else {
      api.reload('0772993c', component.options)
    }
    module.hot.accept("./r-item-trader-config.vue?vue&type=template&id=0772993c", function () {
      api.rerender('0772993c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/trader/r-item-trader-config.vue"
export default component.exports